export default __webpack_public_path__ + "static/media/Fast_Talkin.f7f87d95.mp3";